import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {Sort} from '@angular/material/sort';
import {UserService} from '../../Services/UserService';
import {MatPaginator} from '@angular/material/paginator';
import {Subject} from "rxjs";

interface PatientPagination {
  page: number;        // API uses 1-based index
  size: number;        // Page size
  currentPage: number; // MatPaginator uses 0-based index
}

@Component({
  selector: 'pm-user-creation',
  templateUrl: './user-creation.component.html',
  styleUrls: ['./user-creation.component.css']
})
export class UserCreationComponent implements OnInit {

  tableData: any = [];
  totalRecord: any;
  phoneType: any = [
    {value: 'Mobile', viewValue: 'Mobile'},
    {value: 'Work', viewValue: 'Work'},
    {value: 'Home', viewValue: 'Home'},
  ];
  pagination: PatientPagination = {
    page: 1,         // API uses 1-based index
    size: 10,        // Default page size
    currentPage: 0   // MatPaginator uses 0-based index
  };
  searchText: any;
  isSidebarExpanded = false;
  resetPasswordForm!: FormGroup;
  hidePassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  private clientSub: any;
  private subject: Subject<string> = new Subject();
  @ViewChild('resetPassword') resetPassModal!: ElementRef;
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;

  constructor(private fb: FormBuilder,
              private clientServices: ClientService,
              private userServices: UserService,
              public authService: AuthService,
              private router : Router,
              private renderer: Renderer2,
              private el: ElementRef,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone) {

    this.resetPasswordForm = this.fb.group({
      userName: [null,[Validators.required]],
      /* currentPassword: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],*/
      newPassword: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
      confirmPassword: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
    }, { validators: this.passwordsMatch });
  }
  passwordsMatch(form: FormGroup) {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { mismatch: true };
  }
  ngOnInit(): void {
    this.loadPaginationState(); // Remove pagination state on reload
    this._fetchData(1);
    this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
      if (clientId) {
        this.pagination.page = 1;
        this.pagination.currentPage = 0;
        this._fetchData(1);
      }
    });

    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('userPagination');
    });

  }
  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }
  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageIndex = this.pagination.currentPage; // Restore page index
    }
  }

  // Get Client data
  /*    _fetchData(type?:any) {
          if(type == 1){
              let params: { [key: string]: any } = {
                  page : this.pagination.page,
                  size: this.pagination.size,
                  clientId: this.authService.getClientId() ? this.authService.getClientId() : null,
              };
              this.userServices.getAllUsers(params).pipe(first()).subscribe(
                  (response: any) => {
                      if (response != undefined && response.length > 0) {
                          this.tableData = response;
                          this.totalRecord = response?.totalElements;
                          if (this.paginator) {
                              this.paginator.pageIndex = this.pagination.currentPage; // Ensure paginator sync
                          }
                      } else {
                          swal.fire({
                              title: 'Error!',
                              icon: 'error',
                              text: response.message,
                              showConfirmButton: false,
                              timer: 5000
                          });
                      }
                  },
                  (error) => {
                      swal.fire({
                          title: 'Error!',
                          icon: 'error',
                          text: error.error.message,
                          showConfirmButton: false,
                          timer: 5000
                      });
                  }
              );
          }
          if(type == 2){
              let params ={
                  active: true,
                  clientId: this.authService.clientId
              }
              this.userServices.getAllUsers(params).pipe(first()).subscribe(
                  (response: any) => {
                      if (response != undefined && response.length > 0) {
                          this.tableData = response;
                      } else {
                          swal.fire({
                              title: 'Error!',
                              icon: 'error',
                              text: response.message,
                              showConfirmButton: false,
                              timer: 5000
                          });
                      }
                  },
                  (error) => {
                      swal.fire({
                          title: 'Error!',
                          icon: 'error',
                          text: error.error.message,
                          showConfirmButton: false,
                          timer: 5000
                      });
                  }
              );
          }
          if(type == 3){
              let params ={
                  active: false,
                  clientId: this.authService.clientId
              }
              this.userServices.getAllUsers(params).pipe(first()).subscribe(
                  (response: any) => {
                      if (response != undefined && response.length > 0) {
                          this.tableData = response;
                      } else {
                          swal.fire({
                              title: 'Error!',
                              icon: 'error',
                              text: response.message,
                              showConfirmButton: false,
                              timer: 5000
                          });
                      }
                  },
                  (error) => {
                      swal.fire({
                          title: 'Error!',
                          icon: 'error',
                          text: error.error.message,
                          showConfirmButton: false,
                          timer: 5000
                      });
                  }
              );
          }

      }*/
  _fetchData(type?: number): void {

    let params: { [key: string]: any } = {
      clientId: this.authService.getClientId() || null,
      page: this.pagination.page,
      size: this.pagination.size
    };

    // ✅ Filter by type
    if (type === 2) {
      params.active = true;
    } else if (type === 3) {
      params.active = false;
    }

    this.userServices.getAllUsers(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {

          if (response) {
            const data = response.paginatedUser || [];

            this.tableData = data;
            this.totalRecord = response.totalElements || data.length || 0;

            if (this.paginator) {
              this.paginator.pageIndex = this.pagination.currentPage;
            }

            // 🔥 Fix UI delay issue
            setTimeout(() => {
              this.cdr.detectChanges();
            }, 0);

          } else {
            this.tableData = [];
            this.totalRecord = 0;
            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || response?.detail || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }

        });
      },
      (error) => {
        this.ngZone.run(() => {

          this.tableData = [];
          this.totalRecord = 0;
          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || '',
            showConfirmButton: false,
            timer: 5000
          });

        });
      }
    );
  }

  // Search
  onKeyUp(searchTextValue: any): void {
    this.subject.next(searchTextValue);
  }

  handleKeyUp(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;

    // Trigger search on Enter
    if (event.key === 'Enter') {
      this.onKeyUp(this.searchText);
      return;
    }

    // Existing debounce logic
    this.subject.next(value);
  }
  clearSearch(input: HTMLInputElement) {
    input.value = '';
    /*this.searchString = '';*/
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    this._fetchData(1);
  }

  // pagination changes
  pageChange(event: any) {
    this.pagination.currentPage = event.pageIndex;
    this.pagination.page = this.pagination.currentPage + 1;
    this.pagination.size = event.pageSize;

    sessionStorage.setItem('userPagination', JSON.stringify(this.pagination));

    this._fetchData(1);
  }

  loadPaginationState() {
    const storedData = sessionStorage.getItem('userPagination');

    if (storedData) {
      this.pagination = JSON.parse(storedData);
    }
  }

  // Delete record
  deleteEntry(userId: any) {
    let reqData = {
      userId: userId
    };
    swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this record ?',
      icon: 'warning',
      iconColor: 'red',
      showCancelButton: true,
      confirmButtonText: 'Yes !'
    }).then((result) => {
      if (result.isConfirmed) {
        this.userServices.deleteUser(reqData).pipe(first()).subscribe(
          (response: any) => {
            if (response) {
              this._fetchData(1);
              swal.fire({
                icon: 'success',
                text: 'Record deleted successfully.',
                showConfirmButton: false,
                timer: 2000
              });
            } else {
              swal.fire({
                title: 'Error!',
                icon: 'error',
                text: 'Something went wrong!',
                showConfirmButton: false,
                timer: 2000
              });
            }
          },
          (error) => {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: 'Failed to communicate with the server!',
              showConfirmButton: false,
              timer: 2000
            });
          });
      }
    });
  }

  // Sort form frontend logic
  sortData(sort: Sort) {
    const data = this.tableData.slice();
    if (!sort.active || sort.direction === '') {
      this.tableData = data;
      return;
    }

    this.tableData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'email':
          return compare(a.email, b.email, isAsc);
        case 'number':
          return compare(a.number, b.number, isAsc);
        case 'active':
          return compare(a.active, b.active, isAsc);
        default:
          return 0;
      }
    });
  }

  onSubmit(){
    this.resetPasswordForm.markAllAsTouched()
    if (this.resetPasswordForm.valid) {
      let reqData = {
        userName: this.resetPasswordForm.controls.userName.value,
        /* currentPassword: this.resetPasswordForm.controls.currentPassword.value,*/
        newPassword: this.resetPasswordForm.controls.newPassword.value,
      };
      this.userServices.resetPassword(reqData).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            this.closeModal();
            swal.fire({
              icon: 'success',
              text: 'Password updated successfully.',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    }
  }

  toggleSidebar(): void {
    this.isSidebarExpanded = !this.isSidebarExpanded; // Toggle the state
    const wrapper = this.el.nativeElement.querySelector('#wrapper');
    if (this.isSidebarExpanded) {
      this.renderer.addClass(wrapper, 'toggled');
    } else {
      this.renderer.removeClass(wrapper, 'toggled');
    }
  }
  togglePasswordVisibility(num:any) {
    if(num == 1){
      this.hidePassword = !this.hidePassword;
    }
    if(num == 2){
      this.hideNewPassword = !this.hideNewPassword;
    }
    if(num == 3){
      this.hideConfirmPassword = !this.hideConfirmPassword;
    }
  }
  // method to open the modal and remove background blur
  openModal(data?:any) {
    this.resetPasswordForm.reset()
    const modalElement = this.resetPassModal.nativeElement;
    modalElement.style.display = 'flex'; // Center modal with flexbox
    modalElement.classList.add('show'); // Add the 'show' class for animation

    // Add blur to the background
    this.renderer.addClass(document.body, 'blur-background');
    this.resetPasswordForm.controls.userName.setValue(data)
    // this.resetPasswordForm.get('userName')?.disable();
  }
  // Method to close the modal and remove background blur
  closeModal() {
    this.resetPasswordForm.reset()
    const modalElement = this.resetPassModal.nativeElement;
    modalElement.style.display = 'none'; // Hide modal
    modalElement.classList.remove('show'); // Remove 'show' class

    // Remove blur from the background
    this.renderer.removeClass(document.body, 'blur-background');
  }

  logout() {
    // Clear session storage during logout
    sessionStorage.removeItem('userPagination');
    this.authService.logout();
  }
}



function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
